import script from "./ChargePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChargePage.vue?vue&type=script&setup=true&lang=js"

import "./ChargePage.vue?vue&type=style&index=0&id=adea4758&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adea4758"]])

export default __exports__